import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { InfluencerProposalChat } from './influencer-chat';
import { createPortal } from 'react-dom';
import ConfirmPopup from '../../../components/confirm-popup/confirm-popup';

import {
    CreateCampaign,
    Loading,
    SelectedCampaign,
} from '../../../redux/action';
import { ListService, LocalService } from '../../../core/services';
import './my-campaign.scss';
import MyCampaignCard from '../../../components/my-campaigns-card/my-campaign-card';
import HeadingStyle from '../../../components/heading-style/heading-style';
import { isMobile, isTablet, isBrowser } from 'react-device-detect';
import useBodyClass from '../../../hooks/useBodyClass';
import MobileConfirmPopup from '../../../components/confirm-popup/confirm-popup-mobile';
import InfluencerMobileHeader from '../../../components/header/influencer-mobile-header';
import * as gtUtil from "../../../core/utility"
import { DefaultUserProfile } from '../../../config/config';


interface Props {
    UserReducer: any;
    UserID: any;
    campaignReducer: any;
    loading: (data: any) => void;
    selectedInf?: (data: any) => void;
}

const localService = new LocalService();
const listService: ListService = new ListService();
type Campaign = {
  proposal_id: number;
  completed: boolean;
  // add other fields if needed
};

const InfluencerMyCampaign: React.FC<Props> = (props: Props) => {
    const [campaignList, setCampaignList] = useState<Campaign[]>([]);;
    const [campaign_id, setCampaign_id] = useState({
        campaign_id: 0,
        campaign_platform: "",
    });
    const navigate = useNavigate();
    const [url, setUrl] = useState('');
    const [selectedProposalId, setSelectedProposalId] = useState(0);
    const [popUps, setPopUps] = useState({
        markCompleteConfirmationPopup: false
    });
    const [confirmPopupInnerText, setConfirmPopupInnerText] = useState("Are you sure want to mark complete this campaign?");
    const [btnName, setBtnName] = useState('Apply now');
    const [clearSearch, setClearSearch] = useState(false);
    const [searchValue, setSearchValue] = useState<string>('');
    const [loading, setLoading] = useState(false);
    const [campaignListCopy, setCampaignListCopy] = useState([]);
    
    useEffect(() => {
        getSmId();
    }, [campaign_id.campaign_id, url]);

    // Determine device type
    let device = 'laptop'; // default
    if (isMobile) {
        device = 'mobile';
    } else if (isTablet) {
        device = 'tablet';
    } else if (isBrowser) {
        device = 'laptop';
    }

    async function getSmId() {
        try {
            let sm_id = 0;
            if (campaign_id.campaign_id && url) {
                if (campaign_id.campaign_id > 0) {
                    const response: any = await listService.getAppliedSm_id({
                        influencerId: props?.UserReducer?.influencer_id,
                        campaign_id: campaign_id.campaign_id
                    })

                    if (response.status === 1 && response.data.length > 0) {
                        sm_id = response.data[0].sm_id;
                    }
                }
                navigate(`${url}?campaignId=${campaign_id.campaign_id}&smId=${sm_id}`);
            }
        } catch (error) {
            console.log('getSmId Error :: ', error);
        }
    }

    useEffect(() => {
    props.loading(true);
    listService.get_applied_campaigns({
        influencerId: props.UserReducer.influencer_id,
        campaignId: campaign_id.campaign_id
    }).then((res: any) => {
        if (res.data.status) {
        setBtnName('Applied');
        } else {
        setBtnName('Apply now');
        }
    })
        .catch((error) =>
        console.warn('Influencer applied campaign List Error :: ' + error)
        )
        .finally(() => props.loading(false));
    }, [campaign_id]);

    function setCampaignListFunc() {
        ListService.influencer_mycampaign_List({
            influencerId: props?.UserReducer?.influencer_id,
            device: device
        })
            .then((res: any) => {
                if (res.status === 1) {
                    // setCampaignList(res.data.rows);
                    const formattedData = res.data.rows.map((item: any) => ({
                    ...item,
                    completed: item.completed === true || item.completed === "true"
                    }));

                    setCampaignList(formattedData);
                    setCampaignListCopy(formattedData);
                } else {
                    localService.toastify(res.data.status.message, 'info');
                }
            })
            .catch((error) =>
                console.warn('Influencer campaign List Error :: ' + error)
            )
            .finally(() => props.loading(false));
    }

    useEffect(() => {
        props.loading(true);
        setCampaignListFunc();
    }, [props]);

    function markProposalComplete(proposal_id: number, campaign_title: string) {
        setConfirmPopupInnerText(`Once you mark this campaign as complete, <br/> you won't be able to make any further changes or take additional actions.<br/>  Please confirm you're ready to finish!`);
        setSelectedProposalId(proposal_id);
        setPopUps({ ...popUps, markCompleteConfirmationPopup: true })
        document
            .getElementsByTagName('body')[0]
            .classList.add('custom-drawer-active');
    }

    function handleCloseMarkCompletePopup() {
        setPopUps({ ...popUps, markCompleteConfirmationPopup: false })
        document
            .getElementsByTagName('body')[0]
            .classList.remove('custom-drawer-active');
    }

    // function updateProposalCompleted(proposal_id: number) {
    //     props.loading(true);
    //     ListService.influencer_proposal_mark_complete({
    //         proposal_id: proposal_id,
    //     })
    //         .then((res: any) => {
    //             if (res.data.status === true) {
    //                 setCampaignListFunc();
    //             } else {
    //                 localService.toastify(res.data.status.message, 'info');
    //             }
    //         })
    //         .catch((error) =>
    //             console.warn('Influencer updateProposalCompleted Error :: ' + error)
    //         )
    //         .finally(() => {
    //             handleCloseMarkCompletePopup();
    //         });
    // }

    function updateProposalCompleted(proposal_id: number) {
    props.loading(true);

    // ✅ 1. REMOVE instantly (only mobile)
    if (device === "mobile") {
        setCampaignList((prev: any[]) =>
            prev.filter((item:any) => item.proposal_id !== proposal_id)
        );

        // ✅ Optional: switch tab immediately
        setActiveTab("completed");
    }

    // ✅ 2. API call
    ListService.influencer_proposal_mark_complete({
        proposal_id: proposal_id,
    })
        .then((res: any) => {
            if (res.data.status === true) {
                // ✅ 3. Refresh (sync with backend)
                setCampaignListFunc();
            } else {
                localService.toastify(res.data.status.message, 'info');
            }
        })
        .catch((error) =>
            console.warn('Influencer updateProposalCompleted Error :: ' + error)
        )
        .finally(() => {
            handleCloseMarkCompletePopup();
        });
}
    const [activeTab, setActiveTab] = useState<"applied" | "completed">("applied");
    // const filteredCampaigns = campaignList.filter((res: any) => {
    //     return activeTab === "completed"
    //         ? res.completed === true
    //         : res.completed !== true;
    // });
    // const filteredCampaigns = campaignList.filter((res: any) => {
    //     return activeTab === "completed"
    //         ? res.completed === true
    //         : res.completed !== true;
    // });

    const filteredCampaigns = campaignList.filter((res: any) =>
        activeTab === "completed" ? res.completed : !res.completed
    );
    
    useBodyClass('my-campaign-page')
//   useEffect(() => {  
//     setLoading(true)
//     ListService.influencer_campaign_List({
//       influencer_id: props.UserReducer.influencer_id,
//       device: device,
//     })
//       .then((res: any) => {
//          if (res.data.status === gtUtil.Constants.SUCCESS) {

//     const formattedData = res.data.rows.map((item: any) => ({
//       ...item,
//       completed: item.completed === true || item.completed === "true"
//     }));

//     setCampaignList(formattedData);
//     setCampaignListCopy(formattedData);

//   } else {
//           localService.toastify('No Campaign Found', 'info');
//         }
//       })
//       .catch((error) =>
//         console.warn('Influencer campaign List Error :: ' + error)
//       )
//       .finally(() => {
//         // props.loading(false)
//         setLoading(false)
//       });
//   }, []);
  const handleSearch = (e: any) => {
    const newSearchValue = e.target.value;
    setSearchValue(newSearchValue);

    const lowerCaseSearchValue = newSearchValue.toLowerCase();

    if (lowerCaseSearchValue === '' && lowerCaseSearchValue.length < 3) {
      setCampaignList(campaignListCopy);
      setClearSearch(false);
    } else {
      const newCampaignList = campaignListCopy?.filter((data: any) =>
        data?.campaign_title?.toLowerCase().includes(lowerCaseSearchValue)
      );
      setCampaignList(newCampaignList);
      setClearSearch(true);
    }
  };

  const clearSearchHandler = () => {
    setSearchValue('');
    setClearSearch(false);
    setCampaignList(campaignListCopy);
  };
   const profileImage = props?.UserReducer?.photo || DefaultUserProfile.influencer_unknown_default;
    return (
        <div className='dashboard-infl'>
            <div className='container'>
                <div className='lex-column d-none d-md-flex flex-md-row me-auto mb-3'>
                    <HeadingStyle title='My Campaigns' />
                    {/* <ul className="campaign-legend justify-md-content-end mb-2">
                        <li className="campaign-legend_accepted">Accepted/Approved</li>
                        <li className="campaign-legend_pending">Pending</li>
                        <li className="campaign-legend_rejected">Rejected</li>
                        <li className="campaign-legend_negotiating">Negotiating</li>
                    </ul> */}
                </div>
               
                {device === "mobile" && (
                    <>
                        <InfluencerMobileHeader clearSearch={clearSearch} clearSearchHandler={clearSearchHandler} handleSearch={handleSearch} searchValue={searchValue} profileImage={profileImage} />
                    
                        <div className="campaign-tabs sticky-tabs">
                            <button
                            className={`tab-btn ${activeTab === "applied" ? "active" : ""}`}
                            onClick={() => setActiveTab("applied")}
                            >
                            Applied
                            </button>

                            <button
                            className={`tab-btn ${activeTab === "completed" ? "active" : ""}`}
                            onClick={() => setActiveTab("completed")}
                            >
                            Completed
                            </button>
                        </div>
                    </>
                )}
                <div className='my-campaign-card-container'>
                    {filteredCampaigns?.length > 0 &&
                        filteredCampaigns?.map((res: any, index) => {
                            return (
                                <MyCampaignCard
                                    key={res.proposal_id}
                                    proposalId={res.proposal_id}
                                    campaignId={res.campaign_id}
                                    completed={res.completed}
                                    completedAt={res.completed_at}
                                    campaignPlatform={res.campaign_platform}
                                    campaignImage={res.campaign_cover_url}
                                    campaignTitle={res.campaign_title}
                                    campaignType={res.campaign_type}
                                    campaignStatus={res.campaign_status}
                                    proposalStatus={res.status}
                                    invoiceCount={res.invoice_count}
                                    creativeApproveCount={res?.approved_count}
                                    creativePendingCount={res?.pending_count}
                                    creativeRejectedCount={res?.rejected_count}
                                    AppliedDate={res.created_at}
                                    deliverables={res.deliverables}
                                    posted_days_count={res.posted_days_count}
                                    analyticsCount={res.analytics_count}
                                    btnName={btnName}
                                    handleCampaign={(url, campaign_id, campaign_platform) => {
                                        if (url !== '') {
                                            setUrl(url); setCampaign_id({
                                                campaign_id: campaign_id,
                                                campaign_platform: campaign_platform,
                                            })
                                        }
                                    }}
                                    markProposalComplete={markProposalComplete}
                                    createdAt={res?.created_at}
                                    activeTab={activeTab}
                                />
                            );
                        })}
                    {campaignList.length === 0 && (
                        <p className="no-list-comment" style={{ marginTop: "200px" }}>Great opportunities await! Start exploring and apply to your first campaign today.</p>
                    )}
                </div>
            </div>
            <InfluencerProposalChat />

            {isMobile ? (
                <>
  {/* <MobileConfirmPopup
    open={popUps.markCompleteConfirmationPopup}
                        onClose={handleCloseMarkCompletePopup}
                        onConfirm={() => updateProposalCompleted(selectedProposalId)}
  /> */}
  {createPortal(
  <MobileConfirmPopup
  open={popUps.markCompleteConfirmationPopup}
  onClose={handleCloseMarkCompletePopup}
  onConfirm={() => updateProposalCompleted(selectedProposalId)}
  title="Are you sure?"
  align='bottom'
    description={
    <>
        <p>
        Once you mark this campaign as complete, you won't be able to make any further changes or take additional actions.
        </p>
        <p>Please confirm you're ready to finish!</p>
    </>
    }
  confirmText="Yes"
  cancelText="Cancel"
/>,  document.body)}
</>
) : (
  popUps.markCompleteConfirmationPopup &&
  createPortal(
    <ConfirmPopup
      confirmPopupInnerText={confirmPopupInnerText}
      openPopup={popUps.markCompleteConfirmationPopup}
      confirmClosePopup={handleCloseMarkCompletePopup}
      confirmClickAction={() =>
        updateProposalCompleted(selectedProposalId)
      }
      drawerTitle=""
    />,
    document.body
  )
)}
                
        </div>
    );
};

const mapStateToProps = (state: any) => {
    return {
        UserReducer: state.UserReducer.UserData,
        campaignReducer: state.CreateCampaignReducer,
        UserID: state.UserID.userID,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        CreateCampaignReducer: (data: any) => dispatch(CreateCampaign(data)),
        loading: (data: any) => dispatch(Loading(data)),
        selectedInf: (data: any) => dispatch(SelectedCampaign(data)),
    };
};

const connectToRedux = connect(
    mapStateToProps,
    mapDispatchToProps
)(InfluencerMyCampaign);

export { connectToRedux as InfluencerMyCampaign };
